import { usePlayer } from "../context/PlayerContext";
import { useT } from "../lib/i18n";

const MODES = ["shot", "loop", "hold", "stutter"];

const Seg = ({ items, value, onChange, testid }) => (
  <div className="flex flex-wrap border border-white/10" role="radiogroup">
    {items.map(([k, label]) => (
      <button key={k} role="radio" aria-checked={value === k} data-testid={`${testid}-${String(k).replace("/", "-")}`} onClick={() => onChange(k)}
        className={`px-3 py-2 font-mono text-[11px] uppercase tracking-widest transition-colors ${value === k ? "bg-[#1FD1FF] text-black" : "text-[#A8B3C4] hover:text-white"}`}>
        {label}
      </button>
    ))}
  </div>
);

export const FxModeBar = ({ compact }) => {
  const { fxMode, setFxMode } = usePlayer();
  const { t } = useT();
  const p = compact ? "fx-compact" : "fx";
  return (
    <div className="flex flex-wrap items-center gap-3 mb-5" data-testid={`${p}-mode-bar`}>
      <Seg testid={`${p}-mode`} value={fxMode} onChange={setFxMode} items={MODES.map((m) => [m, t(`fx.mode.${m}`)])} />
    </div>
  );
};
